const CONFIG = {
    api_endpoint: window.myiom_api_endpoint || 'https://localhost:8443/apiv1/',
    application_root: window.application_root || '',
    static_root: window.static_root || './',
    pdf_endpoint: 'https://server4.zolabo.com:5000/exportPDF'
};

export {CONFIG};
